import React, { useState, useEffect } from "react";
import "./styles.less";
import { useTranslation } from "react-i18next";
import { getDefaultLang, langs } from "../../utils";
import { MobileFooter } from "./MobileFooter";
import Tooltip from "rc-tooltip";
const defaultLang = getDefaultLang();

const setCookieLang = (lang) => {
  const topLevelDomain = window.location.hostname
    .split(".")
    .slice(-2)
    .join(".");
  document.cookie = `_authing_lang=${lang}; path=/; domain=${topLevelDomain}`;
};

export const Footer = () => {
  let { i18n, t } = useTranslation();

  const [lang] = useState(defaultLang);
  //
  const change = (event) => {
    const _lang = event.target.value;
    i18n.changeLanguage(_lang);
    setCookieLang(_lang);
    window.location.reload();
  };
  const onOutLink = (path) => {
    window.location.href = path;
  };

  useEffect(() => {
    i18n.changeLanguage(lang);
    setCookieLang(lang);
  }, [lang, i18n]);

  const userManegeList = [
    {
      title: `${t("common.footer.footer-product-advance")}`,
      path: "/advantage",
    },
    {
      title: `${t("common.common.product-verify")}`,
      path: "/verify",
    },
    {
      title: `${t("common.common.product-comp")}`,
      path: "/learn/guard",
    },
    {
      title: `${t("common.common.product-sso")}`,
      path: "/learn/sso",
    },
    {
      title: `${t("common.common.product-mfa")}`,
      path: "/mfa",
    },
  ];

  const solutionList = [
    {
      title: t("common.footer.footer-solution-wechat"),
      path: "/solutions/wechat",
    },
    {
      title: t("common.nav.nav-solution-build-idaas"),
      path: "/solutions/build-idaas",
    },
    {
      title: t("common.nav.nav-solution-idaas"),
      path: "/solutions/idaas",
    },
    {
      title: t("common.nav.nav-solution-okta"),
      path: "/solutions/okta",
    },

    {
      title: t("common.footer.footer-solution-cognito"),
      path: "/solutions/cognito",
    },
  ];

  const developList = [
    {
      title: `${t("common.footer.footer-support-doc")}`,
      path: "//docs.authing.cn/v2",
    },
    {
      title: `${t("common.footer.footer-support-community")}`,
      path: "//forum.authing.cn/",
    },
    {
      title: `${t("common.footer.footer-support-Github")}`,
      path: "//github.com/authing",
    },
    {
      title: `${t("common.footer.footer-support-blog")}`,
      path: "//blog.authing.cn/blog/",
    },
    {
      title: `Authing Timeline`,
      path: "/changelog",
    },
  ];
  const communityLink = [
    {
      imgUrl: "//files.authing.co/authing-website/github.svg",
      icon: "icon authing-icon authing-wechat-pc",
      path: "//github.com/Authing",
      type: "wechat",
    },
    {
      imgUrl: "//files.authing.co/authing-website/github.svg",
      icon: "icon authing-icon authing-github",
      path: "//github.com/Authing",
    },
    {
      imgUrl: "//files.authing.co/authing-website/gitter.svg",
      icon: "icon authing-icon authing-gitter",
      path: "//forum.authing.cn/",
    },
    {
      imgUrl: "//files.authing.co/authing-website/zhihu.svg",
      icon: "icon authing-icon authing-zhihu",
      path: "//www.zhihu.com/org/authing",
    },
  ];

  const menuList = [
    { name: t("common.footer.footer-product"), children: userManegeList },
    { name: t("common.footer.footer-solution"), children: solutionList },
    { name: t("common.footer.footer-support"), children: developList },
    {
      name: t("common.footer.footer-company"),
      children: [
        {
          title: t("common.footer.footer-company-phone"),
          path: null,
        },
        {
          title: t("common.footer.footer-company-email"),
          path: null,
        },
        {
          title: t("common.footer.mobile-total-company-address"),
          path: null,
        },
        {
          title: t("common.footer.mobile-branch-company-address"),
          path: null,
        },
      ],
    },
  ];

  const renderFooter = () => {
    return (
      <div className="authing-pc-footer-display">
        <div className="footer-warp">
          <div className="inner">
            <div className="footer">
              <div
                className="logo"
                onClick={() => {
                  onOutLink("/");
                }}
              >
                <img
                  src={
                    "//files.authing.co/authing-website/authing-logo-new.svg"
                  }
                  alt=""
                />
              </div>
              <div className="block">
                <div className="title">{t("common.footer.footer-product")}</div>
                {userManegeList.map((item, index) => {
                  return (
                    <a key={index} className="item" href={item.path}>
                      {item.title}
                    </a>
                  );
                })}
              </div>
              <div className="block">
                <div className="title">
                  {t("common.footer.footer-solution")}
                </div>
                {solutionList.map((item, index) => {
                  return (
                    <a
                      key={index}
                      className="item"
                      href={item.path}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {item.title}
                    </a>
                  );
                })}
              </div>
              <div className="block">
                <div className="title">{t("common.footer.footer-support")}</div>
                {developList.map((item, index) => {
                  return (
                    <a
                      key={index}
                      className="item"
                      href={item.path}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {item.title}
                    </a>
                  );
                })}
                <a
                  style={{ opacity: 0 }}
                  className="item"
                  href="https://authing.cn/sitemap.xml"
                >
                  {t("common.footer.footer-sitemap")}
                </a>
              </div>
              <div className="block">
                <div className="title">{t("common.footer.footer-company")}</div>
                <a href="/joinus" className="item">
                  {t("common.footer.footer-company-joinus")}
                </a>
                <div className="item-default">400-6197-031</div>
                <div className="item-default">
                  {t("common.footer.footer-company-email")}
                </div>
                <div className="item-default">
                  <Tooltip
                    placement="right"
                    mouseLeaveDelay={0.001}
                    trigger={["hover"]}
                    overlay={t("common.footer.beijing-company-address")}
                  >
                    <span className="companyAddress">
                      {t("common.footer.company-address-name")}
                    </span>
                  </Tooltip>
                  <br />
                  <Tooltip
                    placement="right"
                    mouseLeaveDelay={0.001}
                    trigger={["hover"]}
                    overlay={t("common.footer.chengdu-company-address")}
                  >
                    <span className="companyAddress">
                      {t("common.footer.branch-address-name")}
                    </span>
                  </Tooltip>
                </div>
              </div>
              <div className="address">
                <div className="title">
                  {t("common.footer.footer-language")}
                </div>
                <div className="switch-lang">
                  <select name="lang" onChange={change} value={lang}>
                    {langs.map((item, index) => (
                      <option key={index} value={item.value}>
                        {item.label}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="item gov-link">
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://beian.miit.gov.cn/"
                  >
                    <span>{t("common.footer.footer-adress")}</span>
                  </a>
                </div>
                <div className="item">
                  {t("common.footer.footer-copyright")}
                </div>
                <div className="icons-link">
                  {communityLink.map((item, index) => {
                    if (item.type) {
                      return (
                        <div className="wechat-code">
                          <div key={index} className="icon-link">
                            <i className={item.icon}></i>
                          </div>
                          <div className="wechat-img">
                            <img
                              src="//files.authing.co/authing-website/wechat-code.jpg"
                              alt="authing"
                            />
                          </div>
                        </div>
                      );
                    } else {
                      return (
                        <a
                          key={index}
                          className="icon-link"
                          href={item.path}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <i className={item.icon}></i>
                        </a>
                      );
                    }
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };
  return (
    <>
      <MobileFooter menuList={menuList} communityLink={communityLink} />
      {renderFooter()}
    </>
  );
};
